export class PreventJourneysOverlapError extends Error {
    
}
